const menuList = [
    {
        title: '新建对话',
        key: '/gpt/',
        icon: 'plus'
    },
];

export default menuList;